import { gql } from "@apollo/client";

export const GET_LEAGUES = gql`
  query GetLeaguesWithType {
    leagues(where: {l_is_active: {_eq: true}, l_deleted_at: {_is_null: true}}, order_by: {l_order: asc}) {
      l_id
      l_name
      l_type
    }
  }
`;

export const GET_LEAGUE_TEAMS_BY_LEAGUE_ID = gql`
  query GetLeagueTeamsByLeagueId($l_id: uuid!) {
    league_teams(where: {l_id: {_eq: $l_id}, lt_is_active: {_eq: true}}, order_by: {lt_name: asc}) {
      lt_id
      lt_name
    }
  }
`;

// export const GET_VENUES_BY_LEAGUE_AND_TEAM = gql`
//   query GetVenuesByLeagueAndTeam($l_id: uuid!, $lt_id: uuid!) {
//     league_team_venues(
//       where: { league_team: {l_id: {_eq: $l_id}, lt_id: {_eq: $lt_id}} }
//       order_by: {ltv_name: asc}
//     ) {
//       ltv_id
//       ltv_name
//       av_id
//       all_venue {
//         av_id
//         av_name
//         av_venue_ref_id
//         av_city
//         av_state_code
//       }
//     }
//   }
// `;

// GET_VENUES_BY_LEAGUE_AND_TEAM - Add all missing fields
export const GET_VENUES_BY_LEAGUE_AND_TEAM = gql`
  query GetVenuesByLeagueAndTeam($l_id: uuid!, $lt_id: uuid!) {
    league_team_venues(
      where: { league_team: {l_id: {_eq: $l_id}, lt_id: {_eq: $lt_id}} }
      order_by: {ltv_name: asc}
    ) {
      ltv_id
      ltv_name
      av_id
      all_venue {
        av_id
        av_name
        av_venue_ref_id
        av_timezone      
        av_latitude      
        av_longitude     
        av_street        
        av_city
        av_state_code
        av_zipcode       
        av_country_code  
      }
    }
  }
`;

// GET_ALL_VENUES_WITH_NAME_FILTER - Add all fields
export const GET_ALL_VENUES_WITH_NAME_FILTER = gql`
  query GetAllVenuesWithNameFilter($name: String = "%%", $limit: Int = 50) {
    all_venues(where: {av_name: {_ilike: $name}}, order_by: {av_name: asc}, limit: $limit) {
      av_id
      av_name
      av_venue_ref_id
      av_timezone      
      av_latitude      
      av_longitude     
      av_street        
      av_city
      av_state_code
      av_zipcode       
      av_country_code  
    }
  }
`;
// Enhanced Add Venue mutation
export const ADD_VENUE_TO_TEAM = gql`
  mutation AddVenueToTeam($lt_id: uuid!, $av_id: uuid!, $ltv_name: String!) {
    insert_league_team_venues_one(
      object: {
        lt_id: $lt_id, 
        av_id: $av_id, 
        ltv_name: $ltv_name,
        ltv_is_active: true, 
        ltv_created_at: "now()"  
      }
      on_conflict: { 
        constraint: league_team_venues_av_id_lt_id_key, 
        update_columns: [ltv_is_active, ltv_updated_at] 
      }
    ) {
      ltv_id
      ltv_name
      ltv_is_active
      all_venue {
        av_id
        av_name
        av_city
        av_state_code
        av_latitude
        av_longitude
        av_timezone
      }
    }
  }
`;

// Query to check if venue is properly linked
export const CHECK_VENUE_LINK = gql`
  query CheckVenueLink($lt_id: uuid!, $av_id: uuid!) {
    league_team_venues(
      where: {
        lt_id: {_eq: $lt_id}, 
        av_id: {_eq: $av_id},
        ltv_is_active: {_eq: true}  
      }
    ) {
      ltv_id
      ltv_name
      ltv_is_active
      ltv_created_at
      all_venue {
        av_id
        av_name
        av_city
        av_latitude
        av_longitude
      }
    }
  }
`;

export const ADDING_MULTIPLE_VENUES_INTO_A_TEAM = gql`
  mutation AddMultipleVenuesIntoTeam($venues: [league_team_venues_insert_input!]!) {
    insert_league_team_venues(
      objects: $venues,
      on_conflict: { constraint: league_team_venues_av_id_lt_id_key, update_columns: [] }
    ) {
      returning {
        ltv_id
        ltv_name
      }
    }
  }
`;

export const UPDATE_LEAGUE_TEAM_VENUE_AVID_BY_ID = gql`
  mutation UpdateLeagueTeamVenueAvIdById($ltv_id: uuid!, $av_id: uuid!) {
    update_league_team_venues_by_pk(pk_columns: {ltv_id: $ltv_id}, _set: {av_id: $av_id}) {
      ltv_id
      ltv_name
    }
  }
`;

export const DELETE_VENUE_NAME_BY_ID = gql`
  mutation DeleteVenueNameById($ltv_id: uuid!) {
    delete_league_team_venues_by_pk(ltv_id: $ltv_id) {
      ltv_id
      ltv_name
    }
  }
`;